import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

const ProfilePage = () => {
  
  let navigate = useNavigate();
  
  useEffect(() => {
    localStorage.removeItem("user");
    navigate("/login", {replace: true});
  });
  
}

export default ProfilePage;